module.exports = __webpack_public_path__ + "static/media/Michael_Fang_Headshot.c3f9b891.png";